<template>
  <h1>
    <p class="cn" v-if="title">{{title}}</p>
    <p class="en" v-if="titleEn&&!link">{{titleEn}}</p>
    <p class="link" v-if="titleEn&&link">
      <a :href="link" target="_blank" v-if="link">{{titleEn}}</a>
    </p>
  </h1>
</template>

<script>
export default {
  props: [
    'title', 'title-en', 'link'
  ]
}
</script>

<style lang="sass" scoped>

h1
  text-align: center
  margin-bottom: 40px
  p
    margin: 0 auto!important
  +mobile
    margin-bottom: 20px
  .cn
    font-size: 34px
    color: $black-ter
    +mobile
      font-weight: 500
      font-size: 22px
      color: var(--primary-color)
  .en
    text-transform: uppercase
    font-size: 14px
    color: #888!important
    +tablet
      display: none
  .link
    text-transform: uppercase
    font-size: 14px
    a
      color: #888!important
  &.light .cn
    color: $white
  &.small .cn
    font-size: 30px

</style>
